import {
  CboRecordDto,
  RecordCboUsageRequestDto,
  UpsertCboRecordRequestDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export const cboRecordRequests = {
  getCboRecordByPlaceId: EndpointDefinition.get<
    CboRecordDto | null,
    { placeId: string }
  >({
    name: 'getCboRecordByPlaceId',
    route: '/resourcing/cbo-records/by-place/:placeId',
  }),

  getRecentCboRecords: EndpointDefinition.get<CboRecordDto[], { limit?: number }>({
    name: 'getRecentCboRecords',
    route: '/resourcing/cbo-records/recent',
  }),

  upsertCboRecord: EndpointDefinition.post<CboRecordDto, UpsertCboRecordRequestDto, null>(
    {
      name: 'upsertCboRecord',
      route: '/resourcing/cbo-records',
    }
  ),

  recordCboUsage: EndpointDefinition.post<
    { usageId: string },
    RecordCboUsageRequestDto,
    { id: string }
  >({
    name: 'recordCboUsage',
    route: '/resourcing/cbo-records/:id/usage',
  }),
};
